import React from "react";
import styled from "styled-components";
import { countries, CountryCode } from "@domain/currentProfile/countryCode";
import { Clamp } from "@ui/components/containers/clamp";
import { Primary } from "@ui/components/containers/primary";
//import { MapIcon } from "../icons";
import { CountryFlag } from "@ui/components/CountryFlag";

interface ProfileLocationProps extends React.HTMLAttributes<HTMLDivElement> {
	countryCode: CountryCode;
}

export const ProfileLocation: React.FC<ProfileLocationProps> = ({ countryCode, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{/*<MapIcon />*/}
			<CountryFlag countryCode={countryCode} />
			<Clamp size={1}>
				<Primary>{countries[countryCode]}</Primary>
			</Clamp>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
